import { render } from "./NodeTrueFalse.vue?vue&type=template&id=7e312604"
import script from "./NodeTrueFalse.vue?vue&type=script&lang=js"
export * from "./NodeTrueFalse.vue?vue&type=script&lang=js"
script.render = render

export default script